export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_no.aa766b01d5dd3397.json"